import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';
import { Component, ChangeDetectorRef, OnInit, ViewChild, NgZone, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AllDropdownKeys } from '../../../jurisdiction/jurisdiction.constants';
import { Document, LookupOptionsData } from '../../../jurisdiction/jurisdiction.domain';
import { CommonService } from '../../../services/common.service';
import { first } from 'rxjs/operators';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { GridApplicationDocumentTypes } from '../../entities/enums/grid-application-document-types.enum';
import { ErrorService } from '../../../services/error/error.service';
import { FileService } from '../../../services/file.service';
import { DestroyableComponent } from '../../../common/destroyable.component';
import { LocalStorageService } from '../../../services/local-storage.service';
import { PersonalDataSectionsState } from '../../entities/sections-state/personalDataSectionsState';
import { PersonalDataFormSections } from '../../entities/enums/ui-collection-types.enum';
import { GridConnectionApplicationType } from '../../../constants/app.constants';
import { EnvironmentService } from '../../../services/environment.service';
import { FileEvent } from '../../../+shared/models/fileEvent';
import { EditabilityBasedOnProcessStatus } from '../../entities/editabilityBasedOnProcessStatus';
import { ComponentCanDeactivate } from '../../../+shared/guards/pending-changes-guard.servie';
import { GridApplicationService } from '../../services/grid-application.service';
import { GridApplication } from '../../entities/gridApplication';
import { AreaLocation } from '../../entities/personal-data/areaLocation';
import { AddressAndPersonalData } from '../../entities/personal-data/addressAndPersonalData';
import { ConnectionAddress } from '../../entities/personal-data/connectionAddress';
import { SubscriberAddress } from '../../entities/personal-data/subscriberAddress';
import { GridApplicationCommentsService } from '../../services/grid-application-comments.service';
import { AreaOption } from '../../../model/area-option.model';
import { CompanyData, TechnicianData } from '../../../domains/common.domain';
import { TechnicianResponseData } from '../../../employee-overview/employee-overview.domain';
import { CommunicationService } from '../../../services/communication.service';
import { ApplicationStepType } from 'src/app/+shared/components/application-steps-generic/application-steps-generic.models';

@Component({
  template: '',
})
export abstract class PersonalDataFormNewComponent<GridApp extends GridApplication>
  extends DestroyableComponent
  implements OnInit, ComponentCanDeactivate
{
  @ViewChild('personalDataForm', { read: NgForm }) personalDataForm: any;

  public ApplicationTypes = GridConnectionApplicationType;
  public ApplicationStepType = ApplicationStepType;

  public areaLocations: AreaLocation[];
  public connectionAddressData: ConnectionAddress;
  public subscriberAddress: SubscriberAddress = new SubscriberAddress(null);
  public invoiceAddress: AddressAndPersonalData;
  public operatorPpAddress: AddressAndPersonalData;
  public documentTypes = GridApplicationDocumentTypes;

  public buildingTypeKey: string;
  public titleKey: string;
  public buildingTypes: LookupOptionsData[];
  public allTitles: LookupOptionsData[];
  public locationData: any;
  public useAreaLocation: boolean;
  public isInitialLoad: boolean = true;

  public isConnectionAddressCommentVisible: boolean = false;
  public isSubscriberOwnerCommentVisible: boolean = false;
  public isInvoiceAddressCommentVisible: boolean = false;
  public isPperatorOfPowerPlantCommentVisible: boolean = false;

  public subscriberFormValid: boolean = false;
  public invoiceFormValid: boolean = false;
  public operatorFormValid: boolean = false;
  public applicationNotFinished: boolean = false;
  public isLockUnlockButtonClicked: boolean = false;
  public commentHasBeenUpdated: boolean = false;
  public historyLogForm: FormGroup;
  public isLoading: boolean;
  public preventCanDeactivateCheck: boolean = false;
  public formNames = {
    subscriberForm: 'subscriberForm',
    invoiceForm: 'invoiceForm',
    operatorForm: 'operatorForm',
  };
  public disableConnectionAddressPredefinedFields: boolean;
  public showResponsibleInstaller: boolean = false;

  useDropdownForArea: boolean = this.environmentService.useDropdownForArea;
  areaOptions: AreaOption[] = [];
  SectionIdentifier = SectionIdentifier;

  public get formsValid(): boolean {
    return (
      this.subscriberFormValid &&
      (this.invoiceFormValid || this.subscriberAddress.owner_is_invoice_recepient) &&
      (this.operatorFormValid || this.subscriberAddress.owner_is_pp_operator) &&
      (this.subscriberAddress.owner_is_landlord ||
        (!this.subscriberAddress.owner_is_landlord && this.subscriberAddress?.power_of_attorney?.filename)) &&
      (this.personalDataForm?.valid || this.personalDataForm?.form.status === 'DISABLED')
    );
  }

  public PersonalDataFormSections = PersonalDataFormSections;
  public role: string;
  public personalDataSectionsState: PersonalDataSectionsState;
  public formDirty: boolean = false;
  public step = 3;
  public externalApplicationId: string;
  public applicationTypeText: string;
  public technicianData: TechnicianData = null;
  public companyDataFG: FormGroup = new FormGroup({
    taxId: new FormControl(''),
    companyName: new FormControl(''),
    telephoneNumber: new FormControl(''),
  });

  protected editabilityBasedOnProcessStatus: EditabilityBasedOnProcessStatus = new EditabilityBasedOnProcessStatus();

  @Input() applicationId: number;
  @Input() isDetailsView: boolean = false;
  @Input() showOrderHistory: boolean = true;
  @Input() showStepsWidget: boolean = true;
  @Input() showButtons: boolean = true;
  @Input() showPageHeader: boolean = true;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private gridApplicationService: GridApplicationService<GridApp>,
    private commentService: GridApplicationCommentsService,
    private errorService: ErrorService,
    private fileService: FileService,
    private localStorageService: LocalStorageService,
    private cdRef: ChangeDetectorRef,
    private environmentService: EnvironmentService,
    private communicationService: CommunicationService,
    private zone: NgZone
  ) {
    super();
    this.disableConnectionAddressPredefinedFields = true;
  }

  canDeactivate(): boolean | Promise<boolean> {
    if (this.preventCanDeactivateCheck) {
      return true;
    }

    return (
      !this.personalDataForm?.dirty &&
      !this.formDirty &&
      !this.isLockUnlockButtonClicked &&
      !this.commentHasBeenUpdated &&
      !this.historyLogForm?.dirty
    );
  }

  ngOnInit(): void {
    this.buildingTypeKey = AllDropdownKeys.DevelopmentAreaType;
    this.titleKey = AllDropdownKeys.Title;
    this.buildingTypes = this.commonService.getDropdownData(this.buildingTypeKey);
    this.allTitles = this.commonService.getDropdownData(this.titleKey);
    this.role = this.localStorageService.getItem('role');
    const urlAppilcationId = this.route.snapshot.paramMap.get('id');
    this.applicationId = this.applicationId || Number(this.localStorageService.getItem('application_id'));
    this.applicationNotFinished = !urlAppilcationId || !this.applicationId;
    if (urlAppilcationId && !this.applicationNotFinished) {
      this.loadOrderProcess();

      this.preventLeak(this.gridApplicationService.getApplication(this.applicationId)).subscribe(
        gridApplication => {
          this.externalApplicationId = gridApplication.application_ext_id;
          this.connectionAddressData = gridApplication.connectionobject;
          this.fillSubscriberAddress(gridApplication);

          this.invoiceAddress = gridApplication.invoicerecipient;
          this.operatorPpAddress = gridApplication.app_power_plant_operator_address;
          this.personalDataSectionsState = gridApplication.personal_data_sections_state;
          this.mapAreaOptionsToAreaLocations(gridApplication);
          this.getTechnicianData(gridApplication.technician_id || gridApplication.user_id);
        },
        _ => {},
        () => (this.isLoading = false)
      );
    } else if (this.applicationNotFinished) {
      this.isLoading = true;
      this.preventLeak(this.gridApplicationService.getApplication(this.applicationId)).subscribe(
        gridApplication => {
          this.externalApplicationId = gridApplication.application_ext_id;

          if (Object.keys(gridApplication.connectionobject).length > 0) {
            this.locationData = this.localStorageService.getItem('location_data');
            this.connectionAddressData = gridApplication.connectionobject;
            if (this.locationData) {
              this.connectionAddressData.city = this.locationData.city;
              this.connectionAddressData.postcode = this.locationData.postcode;
              this.connectionAddressData.street = this.locationData.street;
              this.connectionAddressData.street_no = this.locationData.street_number;
            }

            this.fillSubscriberAddress(gridApplication);
            this.invoiceAddress = { ...new AddressAndPersonalData(this.applicationId), ...gridApplication.invoicerecipient };
            this.operatorPpAddress = {
              ...new AddressAndPersonalData(this.applicationId),
              ...gridApplication.app_power_plant_operator_address,
            };
            this.operatorPpAddress.application_id = this.applicationId;

            this.mapAreaOptionsToAreaLocations(gridApplication);
          } else {
            this.applicationNotFinished = false;
            this.initializeNewPersonalData();
          }
        },
        _ => {},
        () => (this.isLoading = false)
      );
    } else {
      this.initializeNewPersonalData();
    }
  }

  private mapAreaOptionsToAreaLocations(gridApplication: GridApp) {
    if (gridApplication.connectionobject.area_locations?.length > 0) {
      this.environmentService.getAreaOptions.then((options: AreaOption[]) => {
        this.useAreaLocation = true;
        this.areaOptions = options;
        this.areaLocations = gridApplication.connectionobject.area_locations?.map(areaLocation => {
          areaLocation.areaOption = this.areaOptions.find(o => o.area === areaLocation.area);
          return areaLocation;
        });
      });
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  public formStateChanged(form: any): void {
    this.formDirty = this.formDirty ? true : form.dirty;
    switch (form.name) {
      case this.formNames.subscriberForm:
        this.subscriberFormValid = form.state;
        break;
      case this.formNames.invoiceForm:
        this.invoiceFormValid = form.state;
        break;
      case this.formNames.operatorForm:
        this.operatorFormValid = form.state;
        break;
    }
  }

  public assignAddress(object: any): void {
    if (!this.locationData) return;

    object.postcode = this.locationData.postcode;
    object.district = this.locationData.district;
    object.city = this.locationData.city;
    object.street = this.locationData.street;
    object.street_no = this.locationData.street_number;
    object.country = this.locationData.country;
  }

  public saveFormData(shouldProceed: boolean): Promise<void> {
    return this.isDetailsView || this.applicationNotFinished ? this.updateForm(shouldProceed) : this.createForm();
  }

  public clearInput(object: any, key: string): void {
    object[key] = null;
  }

  public addLocation(): void {
    this.areaLocations.push({
      area: null,
      field: null,
      field_sector: null,
      areaOption: null,
    });
  }

  public removeLocation(location: AreaLocation): void {
    this.areaLocations = this.areaLocations.filter(x => x !== location);
    this.formDirty = true;
  }

  public invoiceSwitchChanged(recepientOfInvoice: boolean): void {
    this.isInitialLoad = false;

    if (!recepientOfInvoice) {
      this.invoiceFormValid = false;
      this.invoiceAddress = this.invoiceAddress || new AddressAndPersonalData(this.applicationId);
      return;
    }
    this.invoiceFormValid = true;
  }

  public operatorSwitchChanged(operatorOfPowerPlant: boolean): void {
    this.isInitialLoad = false;

    if (!operatorOfPowerPlant) {
      this.operatorFormValid = false;
      this.operatorPpAddress = this.operatorPpAddress || new AddressAndPersonalData(this.applicationId);
      return;
    }
    this.operatorFormValid = true;
  }

  public nextPage(): void {
    this.preventCanDeactivateCheck = true;
    this.proceed();
  }

  public previousPage(): void {
    this.location.back();
  }

  public lockSection(section: PersonalDataFormSections): void {
    if (this.isModeratorRole()) {
      switch (section) {
        case PersonalDataFormSections.ConnectionAddress:
          this.personalDataSectionsState.is_connection_address_locked = this.personalDataSectionsState.is_connection_address_locked
            ? null
            : true;
          break;
        case PersonalDataFormSections.SubscriberOwner:
          this.personalDataSectionsState.is_subscriber_owner_locked = this.personalDataSectionsState.is_subscriber_owner_locked
            ? null
            : true;
          break;
        case PersonalDataFormSections.InvoiceAddress:
          this.personalDataSectionsState.is_invoice_address_locked = this.personalDataSectionsState.is_invoice_address_locked ? null : true;
          break;
        case PersonalDataFormSections.OperatorOfPowerPlant:
          this.personalDataSectionsState.is_operator_of_power_plant_locked = this.personalDataSectionsState
            .is_operator_of_power_plant_locked
            ? null
            : true;
          break;
      }
      this.isLockUnlockButtonClicked = true;
    }
  }

  public clearFile(fileEvent: FileEvent): void {
    this.preventLeak(this.gridApplicationService.deleteApplicationDocuments(fileEvent.documentId)).subscribe(
      (response: any) => {
        this.errorService.throwErrorIfFailure(response, true);
        this.formDirty = true;
      },
      error => {
        this.errorService.throwErrorIfFailure(error, true);
      }
    );

    this.subscriberAddress.power_of_attorney = new Document(this.documentTypes.PowerOfAttorney);
  }

  public isDisabled(): boolean {
    return (
      (!this.environmentService.shouldInternalRolesBeAbleToEditApplication && (this.isModeratorRole() || this.role === 'observer')) ||
      !this.isEditableByExternalRoles()
    );
  }

  public isModeratorRole(): boolean {
    return this.role === 'employee' || this.role === 'administrator';
  }

  private isTechnicianRole(): boolean {
    return this.role === 'standard_technician' || this.role === 'guest_technician';
  }

  private isCustomerRole(): boolean {
    return this.role === 'customer';
  }

  public isEditableByInternalRoles(): boolean {
    return this.isModeratorRole() && this.editabilityBasedOnProcessStatus.internalRoles;
  }

  public isEditableByExternalRoles(): boolean {
    return (
      (this.isTechnicianRole() && this.editabilityBasedOnProcessStatus.technicianRole) ||
      (this.isCustomerRole() && this.editabilityBasedOnProcessStatus.customerRole)
    );
  }

  public areaLocationsTrackBy(i: number): number {
    return i;
  }

  public selectArea(value: AreaOption, index: number) {
    this.areaLocations[index] = { ...this.areaLocations[index], area: value.area, postcode: value.zip };
  }

  public getAreaOption(postcode: string) {
    return this.areaOptions.find(a => a.zip === postcode);
  }

  protected abstract loadOrderProcess(): void;

  protected proceed() {
    const url = this.isDetailsView
      ? `/${this.route.snapshot.data.module}/documents/${this.applicationId}`
      : `/${this.route.snapshot.data.module}/documents`;
    this.preventCanDeactivateCheck = true;
    this.router.navigate([url]);
  }

  private async saveComment(): Promise<void> {
    if (this.personalDataSectionsState.application_id) {
      await this.commentService.updatePersonalDataSectionComment(this.personalDataSectionsState).toPromise();
    } else {
      this.personalDataSectionsState.application_id = this.applicationId;
      await this.commentService.createPersonalDataSectionComment(this.personalDataSectionsState).pipe(first()).toPromise();
    }

    this.commentHasBeenUpdated = true;
    this.updateLocalStorageForSectionState();
  }

  private initializeModels(application_id: number): void {
    this.connectionAddressData = new ConnectionAddress(application_id);
    this.subscriberAddress = new SubscriberAddress(application_id);
    this.invoiceAddress = new AddressAndPersonalData(application_id);
    this.operatorPpAddress = new AddressAndPersonalData(application_id);
    this.areaLocations = [new AreaLocation()];
  }

  private initializeNewPersonalData(): void {
    this.applicationId = Number(this.localStorageService.getItem('application_id'));
    this.locationData = this.localStorageService.getItem('location_data');
    this.initializeModels(this.applicationId);
    this.connectionAddressData.postcode = this.locationData?.postcode;

    if (this.locationData?.field_sector) {
      this.useAreaLocation = true;

      if (this.useDropdownForArea) {
        this.environmentService.getAreaOptions.then((options: AreaOption[]) => {
          this.areaOptions = options;
          this.areaLocations[0].areaOption = this.areaOptions.find(o => o.area === this.locationData.area);
        });
      } else {
        this.areaLocations[0].area = this.locationData.area;
      }

      this.areaLocations[0].postcode = this.locationData.postcode;
      this.areaLocations[0].area = this.locationData.area;
      this.areaLocations[0].field = this.locationData.field;
      this.areaLocations[0].field_sector = this.locationData.field_sector;
    } else {
      this.useAreaLocation = false;
      this.connectionAddressData.is_address_assigned = true;
      this.assignAddress(this.connectionAddressData);
    }
  }

  private fillSubscriberAddress(gridApplication: GridApplication) {
    const switchDefaultValue = this.environmentService.setDefaultToggleStates ? true : false;
    this.subscriberAddress = gridApplication.businesspartner;
    this.subscriberAddress.owner_is_landlord = JSON.parse(String(gridApplication.businesspartner?.owner_is_landlord ?? switchDefaultValue));
    this.subscriberAddress.owner_is_pp_operator = JSON.parse(
      String(gridApplication.businesspartner?.owner_is_pp_operator ?? switchDefaultValue)
    );
    this.subscriberAddress.owner_is_invoice_recepient = JSON.parse(
      String(gridApplication.businesspartner?.owner_is_invoice_recepient ?? switchDefaultValue)
    );

    this.subscriberAddress.power_of_attorney =
      gridApplication.document.find(d => d.sk_document_type === GridApplicationDocumentTypes.PowerOfAttorney) ??
      new Document(GridApplicationDocumentTypes.PowerOfAttorney);
  }

  private uploadPowerOfAttorney(powerOfAttorneyDocument: Document) {
    if (powerOfAttorneyDocument.file) {
      this.preventLeak(
        this.fileService.uploadSingleDocument(
          powerOfAttorneyDocument.file,
          this.applicationId.toString(),
          powerOfAttorneyDocument.sk_document_type,
          powerOfAttorneyDocument.name
        )
      ).subscribe(
        (response: any) => {
          this.errorService.throwErrorIfFailure(response, true);
          powerOfAttorneyDocument.document_id = response.document[0]?.document_id;
        },
        error => {
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    }
  }

  private async createForm(): Promise<void> {
    this.connectionAddressData.area_locations = this.useAreaLocation ? this.areaLocations : [];
    this.isLoading = true;
    if (!this.subscriberAddress.owner_is_landlord) {
      this.uploadPowerOfAttorney(this.subscriberAddress.power_of_attorney);
    }

    let response = await this.gridApplicationService.createConnectionObject(this.connectionAddressData).pipe(first()).toPromise();
    this.connectionAddressData.connectionobject_id = response['connectionobject'][0].connectionobject_id;

    response = await this.gridApplicationService.createBussinessPartner(this.subscriberAddress).pipe(first()).toPromise();
    this.subscriberAddress.businesspartner_id = response['businesspartner'][0].businesspartner_id;

    if (!this.subscriberAddress.owner_is_invoice_recepient) {
      response = await this.gridApplicationService.createInvoiceAddress(this.invoiceAddress).pipe(first()).toPromise();
      this.invoiceAddress.id = response['invoicerecipient'][0].recipient_id;
    }
    if (!this.subscriberAddress.owner_is_pp_operator) {
      response = await this.gridApplicationService.createPpOperatorAddress(this.operatorPpAddress).pipe(first()).toPromise();
      this.operatorPpAddress.id = response;
    }
    this.isLoading = false;
    this.zone.run(() => {
      this.preventCanDeactivateCheck = true;
      this.proceed();
    });
  }

  private async updateForm(shouldProceed: boolean): Promise<void> {
    if (this.role !== 'observer') {
      this.connectionAddressData.area_locations = this.useAreaLocation ? this.areaLocations : [];
      this.isLoading = true;

      if (!this.subscriberAddress.owner_is_landlord) {
        this.uploadPowerOfAttorney(this.subscriberAddress.power_of_attorney);
      } else if (this.applicationNotFinished && this.subscriberAddress.power_of_attorney.document_id) {
        this.clearFile(new FileEvent(+this.subscriberAddress.power_of_attorney.document_id));
      }

      this.connectionAddressData['personal_data_sections_state'] = this.personalDataSectionsState;

      let response = await this.gridApplicationService
        .updateConnectionObject(
          { ...this.connectionAddressData, connectionobject_id: 0, application_id: 0 },
          this.connectionAddressData.connectionobject_id
        )
        .pipe(first())
        .toPromise();

      this.areaLocations = response.connectionobject[0].area_locations;

      if (this.subscriberAddress.businesspartner_id) {
        response = await this.gridApplicationService
          .updateBussinessPartner(
            { ...this.subscriberAddress, businesspartner_id: 0, application_id: 0 },
            this.subscriberAddress.businesspartner_id
          )
          .pipe(first())
          .toPromise();
      } else {
        response = await this.gridApplicationService
          .createBussinessPartner({ ...this.subscriberAddress, application_id: this.applicationId })
          .pipe(first())
          .toPromise();
      }

      const recipient_id = this.invoiceAddress.recipient_id || this.gridApplicationService.gridApplication.invoicerecipient.recipient_id;

      if (!this.subscriberAddress.owner_is_invoice_recepient) {
        if (recipient_id) {
          response = await this.gridApplicationService
            .updateInvoiceAddress({ ...this.invoiceAddress, recipient_id: 0, application_id: 0 }, recipient_id.toString())
            .pipe(first())
            .toPromise();
        } else {
          response = await this.gridApplicationService.createInvoiceAddress(this.invoiceAddress).pipe(first()).toPromise();
          this.invoiceAddress.id = response['invoicerecipient'][0].recipient_id;
        }
      } else if (recipient_id) {
        await this.gridApplicationService.deleteInvoiceAddress(recipient_id).pipe(first()).toPromise();
      }

      if (this.operatorPpAddress) {
        if (!this.subscriberAddress.owner_is_pp_operator) {
          if (this.operatorPpAddress.id) {
            response = await this.gridApplicationService.updatePpOperatorAddress(this.operatorPpAddress).pipe(first()).toPromise();
          } else {
            response = await this.gridApplicationService.createPpOperatorAddress(this.operatorPpAddress).pipe(first()).toPromise();
          }
        } else if (this.operatorPpAddress.id) {
          response = await this.gridApplicationService.deletePpOperatorAddress(this.operatorPpAddress.id).pipe(first()).toPromise();
        }
      }
      this.updateLocalStorageForSectionState();
      this.isLockUnlockButtonClicked = false;
      this.formDirty = false;
      this.isLoading = false;
    }
    if (shouldProceed) {
      this.zone.run(() => {
        this.preventCanDeactivateCheck = true;
        this.proceed();
      });
    }
  }

  private updateLocalStorageForSectionState(): void {
    const gridApplication = this.gridApplicationService.gridApplication;
    gridApplication.personal_data_sections_state = this.personalDataSectionsState;
    gridApplication.connectionobject = this.connectionAddressData;
    gridApplication.businesspartner = this.subscriberAddress;
    gridApplication.invoicerecipient = this.invoiceAddress;
    gridApplication.app_power_plant_operator_address = this.operatorPpAddress;

    let powerOfAttorneyDocument = gridApplication.document.find(d => d.sk_document_type === GridApplicationDocumentTypes.PowerOfAttorney);
    if (!powerOfAttorneyDocument && this.subscriberAddress?.power_of_attorney?.filename) {
      let powerOfAttorneyDoc = new Document(GridApplicationDocumentTypes.PowerOfAttorney);
      powerOfAttorneyDoc.filename = this.subscriberAddress.power_of_attorney?.filename;
      powerOfAttorneyDoc.document_id = this.subscriberAddress.power_of_attorney?.document_id;
      gridApplication.document.push(powerOfAttorneyDoc);
    } else if (powerOfAttorneyDocument) {
      powerOfAttorneyDocument.filename = this.subscriberAddress.power_of_attorney?.filename;
      powerOfAttorneyDocument.document_id = this.subscriberAddress.power_of_attorney?.document_id;
    }
  }

  private getTechnicianData(technicianId): void {
    this.isLoading = true;
    this.communicationService.getData(`technician?technician_id=${technicianId}`).subscribe(
      (response: TechnicianResponseData) => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(response, true);
        this.technicianData = (response.technician && response.technician[0]) || null;
        this.prepareInstallerData();
      },
      error => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  private prepareInstallerData(): void {
    const companyData: CompanyData = (this.technicianData?.company && this.technicianData?.company[0]) || null;
    this.companyDataFG = new FormGroup({
      taxId: new FormControl(companyData?.tax_id || ''),
      companyName: new FormControl(companyData?.company_name || ''),
      telephoneNumber: new FormControl(companyData?.telephone || ''),
    });
  }
}
